export default __webpack_public_path__ + "e6bd6f31326c6abbf252c08103e96c7c.jpg";